import React, { Dispatch, SetStateAction, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import './menu.css'
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { BorderMenuPage, contentMenuList, DisplayMenuItem, emptyMenuPage, MenuContentPage, typeDailyMenu } from "../types/types";
import { PageMenu } from "../pageMenu/pageMenu";
import RightBar from "./RightBarRestau/RightBarRestau";
import { MdFullscreen,  MdOutlinePhotoCamera } from "react-icons/md";
import { TfiClose } from "react-icons/tfi";
import MaskBackground from "../maskBackground/maskBackground";
import { getMenuAndStyle, getPeriodDisplay, isPdfMenuItem } from "../../screen/Restaurateur/menu/homeMenu/hookModifyHomeMenu";
import { DailyMenuList } from "./hookMenu";
interface MenuProps {
    listMenu:contentMenuList[],
    fullScreen:boolean,
    setFullScreen:Dispatch<SetStateAction<boolean>>,
    setFullPlat?:Dispatch<SetStateAction<string>>,
    startPage?:[number,number],
    currentDaily?:boolean,
    dailyMenu?:typeDailyMenu,
}

export function useIsPinchZoomed(isMobile: boolean) {
  const isZoomedRef = useRef(false); 

  useEffect(() => {
    if (!isMobile) return;
    let raf = 0;

    const update = () => {
      raf = 0;
      const scale = vv?.scale ?? 1;
      isZoomedRef.current = scale > 1.01;
    };


    const onChange = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const vv = (window as any).visualViewport;
    if (vv) {
      vv.addEventListener("resize", onChange, { passive: true });
      vv.addEventListener("scroll", onChange, { passive: true });
      update();
      return () => {
        vv.removeEventListener("resize", onChange);
        vv.removeEventListener("scroll", onChange);
        if (raf) cancelAnimationFrame(raf);
      };
    }

    const onWindowChange = () => {
      const ratio = document.documentElement.clientWidth / window.innerWidth;
      isZoomedRef.current = ratio < 0.98;
    };
    window.addEventListener("resize", onWindowChange, { passive: true });
    window.addEventListener("orientationchange", onWindowChange);
    onWindowChange();
    return () => {
      window.removeEventListener("resize", onWindowChange);
      window.removeEventListener("orientationchange", onWindowChange);
    };
  }, [isMobile]);

  return { isZoomedRef };
}
function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        function checkMobile() {
        setIsMobile(window.matchMedia('(max-width: 1050px)').matches);
        }
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return isMobile;
}

const MenuRestau:React.FC<MenuProps> = ({listMenu,setFullPlat,fullScreen,setFullScreen,startPage,currentDaily=false,dailyMenu}) => {
    const [pageShow, setPageShow] = useState([0,1])
    const [borderPages,setBorderPages] = useState<BorderMenuPage | null>(null)
    const [maxIndex,setMaxIndex] = useState(5)
    const [borderStyleVars, setBorderStyleVars] = useState<React.CSSProperties>({});

    const [uniqueMenuDesk, setUniqueMenuDesk] = useState<contentMenuList | null>(null);
    const uniqueNameMenu = uniqueMenuDesk?.name || 'La Carte';
    const uniqueStyleMenu = uniqueMenuDesk?.stylemenu || 0;
    const uniqueInteractMenu = uniqueMenuDesk?.interactmenu || false;
    const [openedMenu, setOpenedMenu] = useState<contentMenuList | null>(null);
    const openedStyleMenu = openedMenu?.stylemenu || 0;
    const openedInteractMenu = openedMenu?.interactmenu || false;
    const [menuPdf,setMenuPdf] = useState<contentMenuList | null>(null)
    const [dailyMenuFullScreen,setDailyMenuFullScreen] = useState<typeDailyMenu | null>(null)
    const dobbleMenu = React.useMemo<[MenuContentPage, MenuContentPage][]>(() => {
        if (!openedMenu && !uniqueMenuDesk) {
            return [[emptyMenuPage, emptyMenuPage]];
        }
        if(openedMenu) {
            const [groups] = getMenuAndStyle(openedMenu);
            const patch = groups && groups[0] && groups[0][1].imgback ? { imgback: groups[0][1].imgback } : {};
            const patchColor = groups && groups[0] && groups[0][1].colorback ? {colorback: groups[0][1].colorback} : {}
            let emptyMenupageUse = {...emptyMenuPage,...patch, ...patchColor}
            if (groups && groups[groups.length-1][1].elements.length > 0) groups.push([emptyMenupageUse, emptyMenupageUse])
            return groups ?? [[{...emptyMenuPage}, emptyMenuPage]];
        }else if(uniqueMenuDesk) {
            const [groups] = getMenuAndStyle(uniqueMenuDesk);
            const patch = groups && groups[0] && groups[0][1].imgback ? { imgback: groups[0][1].imgback } : {};
            const patchColor = groups && groups[0] && groups[0][1].colorback ? {colorback: groups[0][1].colorback} : {}
            let emptyMenupageUse = {...emptyMenuPage,...patch, ...patchColor}
            if (groups && groups[groups.length-1][1].elements.length > 0) groups.push([emptyMenupageUse, emptyMenupageUse])
            return groups ?? [[emptyMenuPage, emptyMenuPage]];
        }
        return [[emptyMenuPage, emptyMenuPage]];
    }, [openedMenu,uniqueMenuDesk]);
    const mergedMenuList = React.useMemo<DisplayMenuItem[]>(() => {
        const normalMenus: DisplayMenuItem[] = listMenu.map((menu, index) => ({
            type: "menu",
            data: menu,
            sourceIndex: index,
        }));
        const dailyItems: DisplayMenuItem[] = dailyMenu && dailyMenu.image ? [{ type: "daily", data: dailyMenu, sourceIndex: null }] : [];
        const merged = [...normalMenus, ...dailyItems];
        return merged.sort((a, b) => {
            const aOrder = a.data.display_order ?? 0;
            const bOrder = b.data.display_order ?? 0;

            if (aOrder !== bOrder) return aOrder - bOrder;

            if (a.type === "daily" && b.type === "menu") return -1;
            if (a.type === "menu" && b.type === "daily") return 1;

            return 0;
        });
    }, [listMenu, dailyMenu]);
    useEffect(() => {
        if(mergedMenuList && mergedMenuList.length && mergedMenuList.length === 1 && mergedMenuList[0].type === 'menu' && mergedMenuList[0].data.menu) setUniqueMenuDesk(mergedMenuList[0].data)
    },[mergedMenuList])
    const openMenu = (menu: contentMenuList) => {
        setOpenedMenu(menu);
        setPageShow([0, 1]);
        setFullScreen(true);
    };
    const closeMenu = () => {
        if (isMobile) {
            restoreMobilePositionRef.current = true;
        }
        setOpenedMenu(null);
        setPageShow([0, 1]);
        setFullScreen(false);
    };
    const handleOpenMenuMobile = (menu: contentMenuList) => {
        if (isMobile) {
             lastMobileActiveIndexRef.current = activeIndex;
            restoreMobilePositionRef.current = true;
            openMenu(menu);
            nudgeScroll();
        }
    };
    const handleOpenMenuDesktop = async (menu: contentMenuList,id:number) => {
        if (id !== activeIndex) {
            scrollToIndex(id);
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        openMenu(menu);
    };
    const handleOpenMenuPdf = async (menu: contentMenuList,id:number,isDesktop:boolean) => {
        if (isDesktop && id !== activeIndex) {
            scrollToIndex(id);
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        setMenuPdf(menu);
    };

    const listRefComputer = useRef<HTMLDivElement | null>(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const lastMobileActiveIndexRef = useRef(0);
    const restoreMobilePositionRef = useRef(false);
    const menuItemRefs = useRef<(HTMLElement | null)[]>([]);
    const mobileMenuItemRefs = useRef<(HTMLElement | null)[]>([]);
    const setMenuItemRef = useCallback(
        (index: number, el: HTMLElement | null) => {
            menuItemRefs.current[index] = el;
        },
    []);
    const scrollToIndex = (idx: number) => {
        const scroller = listRefComputer.current;
        if (!scroller) return;
        //const items = Array.from(scroller.querySelectorAll<HTMLElement>(".containerMenu"));
        const items = menuItemRefs.current;
        const el = items[idx];
        if (!el) return;
        const left = el.offsetLeft + el.offsetWidth / 2 - scroller.clientWidth / 2;
        scroller.scrollTo({ left, behavior: "smooth" });
    };
    const scrollToMobileIndex = useCallback((idx: number, behavior: ScrollBehavior = "smooth") => {
        const scroller = listRef.current;
        if (!scroller) return;
        //const items = Array.from(scroller.querySelectorAll<HTMLElement>(".containerCoverMenu"));
        const items = mobileMenuItemRefs.current;
        const el = items[idx];
        if (!el) return;
        const left = el.offsetLeft + el.offsetWidth / 2 - scroller.clientWidth / 2;
        scroller.classList.add("snapOff");
        scroller.scrollTo({ left, top: 0, behavior });

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                scroller.scrollTo({ left, top: 0, behavior: behavior });
                scroller.classList.remove("snapOff");
            });
        });
    }, []);
    useLayoutEffect(() => {
        const scroller = listRefComputer.current;
        if (!scroller) return;
        scalesRef.current.clear();

        let raf = 0;
        const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));
        const round2 = (v: number) => Math.round(v * 100) / 100;
        const update = (now: number) => {
            raf = 0;
            //const items = Array.from(scroller.querySelectorAll<HTMLElement>(".containerMenu"));
            const items = menuItemRefs.current;
            if (items.length === 0) return;
            for (const el of items) {
                if(!el) continue
                if (!scalesRef.current.has(el)) scalesRef.current.set(el, 1);
            }

            const rW = scroller.clientWidth;
            const centerX = scroller.scrollLeft + rW / 2;
            const sl = scroller.scrollLeft;
            const prevSl = lastScrollLeftRef.current;
            const prevT = lastTRef.current;
            const dt = Math.max(16, prevT ? now - prevT : 16);
            const velocity = Math.abs(sl - prevSl) / dt;
            lastScrollLeftRef.current = sl;
            lastTRef.current = now;

            const range = rW * 0.55;
            const lerpFactor = velocity > 1.2 ? 0.22 : 0.35;
            const threshold = velocity > 1.2 ? 0.0035 : 0.0025;

            let bestIdx = 0;
            let bestDist = Infinity;

            for (let i = 0; i < items.length; i++) {
            const el = items[i];
            if (!el) continue;
            const itemCenter = el.offsetLeft + el.offsetWidth / 2;
            const dist = Math.abs(itemCenter - centerX);
            if (dist < bestDist) {
                bestDist = dist;
                bestIdx = i;
            }
            const t = clamp(dist / range, 0, 1);
            const target = 1.013 - t * 0.38;
            const current = scalesRef.current.get(el) ?? 1;
            const next = current + (target - current) * lerpFactor;
            const rounded = round2(next);

            if (Math.abs(rounded - current) > threshold) {
                el.style.setProperty("--qr-scale", String(rounded));
                scalesRef.current.set(el, rounded);
            }
            }
            setActiveIndex(bestIdx);
        };
        const schedule = () => { if (!raf) raf = requestAnimationFrame((t) => update(t));};
        scroller.addEventListener("scroll", schedule, { passive: true });
        window.addEventListener("resize", schedule, { passive: true });
        requestAnimationFrame((t) => {
            scrollToIndex(0);
            update(t);
            requestAnimationFrame((t2) => {
            update(t2);
            setScaleReady(true);
            });
        });

        return () => {
            scroller.removeEventListener("scroll", schedule);
            window.removeEventListener("resize", schedule);
            if (raf) cancelAnimationFrame(raf);
        };
    }, [mergedMenuList.length]);
    
    const zCounterRef = useRef(1);
    
    useEffect(() => {
        zCounterRef.current = dobbleMenu.length * 2;
    }, [dobbleMenu.length]); 
    const Z_MAX = 200; 

    const renormalizeZ = () => {
        const nodes = document.querySelectorAll<HTMLElement>(".menuRestauTel .pageRestauTel");
        let z = 1;
        nodes.forEach((n) => {
            n.style.zIndex = String(z++);
        });
        zCounterRef.current = z;
    };
    const canUseContentVisibility = typeof CSS !== "undefined" && CSS.supports?.("content-visibility", "auto");
    const bringToFront = (el: HTMLElement) => {
        el.style.zIndex = String(zCounterRef.current++);
        if (zCounterRef.current > Z_MAX) renormalizeZ();
    };
    const nudgeScroll = () => {
        requestAnimationFrame(() => {
            const y = window.scrollY || document.documentElement.scrollTop || 0;
            window.scrollTo(0, y + 10);
            requestAnimationFrame(() => window.scrollTo(0, y));
        });
    };
    const isMobile = useIsMobile();
    const lengthMenuPhone = React.useMemo(() => {
        if (!dobbleMenu || !dobbleMenu.length) return 0;
        if (dobbleMenu.length < 2) return 1;

        const last = dobbleMenu[dobbleMenu.length - 1];
        const backEmpty = last[1].elements.length === 0;
        const frontEmpty = last[0].elements.length === 0;

        const penalty = backEmpty ? (frontEmpty ? 3 : 2) : 1;
        return dobbleMenu.length * 2 - penalty;
    }, [dobbleMenu]);
    useEffect(() => { 
        if(dobbleMenu && dobbleMenu.length > 1 && 'borderpage' in dobbleMenu[0][1] && dobbleMenu[0][1].borderpage) {
            setBorderPages(dobbleMenu[0][1].borderpage as BorderMenuPage| null)
            const {color, colorline} = dobbleMenu[0][1].borderpage
            setBorderStyleVars(() => {
                const vars: React.CSSProperties = {};

                if (color) {
                (vars as any)['--qr-border-bg-strong'] = color;
                (vars as any)['--qr-border-bg-soft'] = color;
                }

                if (colorline) {
                (vars as any)['--qr-border-line'] = colorline;
                }

                return vars;
            });
        }
        setMaxIndex(dobbleMenu.length)
    },[dobbleMenu]) 
    useEffect(() => {
        setPageShow([0,1])
        setTimeout(() => {
            if(startPage){
                let testStart= [0,1]
                while(testStart[0] !== startPage[0] && testStart[1] !== startPage[1]) {
                    const movePage = document.getElementById(`pageRestau${testStart[1]}`)
                    const nextMovePage = document.getElementById(`pageRestau${testStart[1]+1}`)   
                    if(movePage) {
                        requestAnimationFrame(() => {
                            movePage.classList.add("flipped")
                            bringToFront(movePage)
                        })
                    }
                    setPageShow([testStart[0]+1,testStart[1]+1])
                    testStart = [testStart[0]+1,testStart[1]+1]
                    if(nextMovePage) {
                        setTimeout(() => {
                            bringToFront(nextMovePage)
                        }, 100);     
                    }
                }
            }
        },250)
    }, []);
    const [isTurning, setIsTurning] = useState(false);
    const clickRightPage = () => {
        if (isTurning) return; 
        setIsTurning(true);
        const movePage = document.getElementById(`pageRestau${pageShow[1]}`)
        const nextMovePage = document.getElementById(`pageRestau${pageShow[1]+1}`)   
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.add("flipped")
                bringToFront(movePage)
            })
        }
        setPageShow([pageShow[0]+1,pageShow[1]+1])
        if(nextMovePage) {
            setTimeout(() => {
                bringToFront(nextMovePage)
            }, 300);     
        }
        setTimeout(() => setIsTurning(false), 200);
    }
    const clickLeftPage = () => {
        if (isTurning) return; 
        setIsTurning(true);
        const movePage = document.getElementById(`pageRestau${pageShow[0]}`)    
        if(pageShow[0]-1 === -1) setPageShow([0,1])
        else setPageShow([pageShow[0]-1,pageShow[1]-1])
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.remove("flipped") 
                bringToFront(movePage)
            })
        }
        setTimeout(() => setIsTurning(false), 200);
    }
    const clickRightPageTel = () => {
        if (isTurning) return; 
        setIsTurning(true);
        let pageToMove = 'pageRestauTel' 
        const movePage = document.getElementById(pageToMove + (pageShow[0] === pageShow[1] ? '0' : '1') +  pageShow[1])
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.add("flipped")
                bringToFront(movePage)
                
            })
        }
        setPageShow(prev => {
            const [a, b] = prev;
            return (a === b) ? [a, b + 1] : [b, b];
        });
    
        setTimeout(() => setIsTurning(false), 300);
    }
    const clickLeftPageTel = () => {
        if (isTurning) return; 
        setIsTurning(true);
        let pageToMove = 'pageRestauTel'
        const movePage = document.getElementById(pageToMove + (pageShow[0] === pageShow[1] ? '1' : '0') +  pageShow[0]) 
        if(movePage) {
            requestAnimationFrame(() => {
                movePage.classList.remove("flipped") 
                bringToFront(movePage)
            })
        }
        setPageShow(prev => {
    const [a, b] = prev;
    if (a - 1 < 0) return [0, 1];

    if (a === b) return [a - 1, b];
    return [a, a];
  });
        setTimeout(() => setIsTurning(false), 300);
    }

    const touchStartX= useRef(0);
    const touchStartY = useRef(0);
    const isHorizontalSwipe = useRef(false);
    const {  isZoomedRef } = useIsPinchZoomed(isMobile);
    const isSwipeBlocked = useRef(false);
    const pinchDetected = useRef(false);
    const handleTouchStart = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        if (!fullScreen) return;
        pinchDetected.current = false;
        if (e.touches.length > 1) {
            pinchDetected.current = true;
            return;
        }
        isSwipeBlocked.current = !!isMobile && isZoomedRef.current;
        if (isSwipeBlocked.current) {
            return;
        }
        touchStartX.current = e.touches[0].clientX;
        touchStartY.current = e.touches[0].clientY;
        isHorizontalSwipe.current = false;
    }, [fullScreen,isMobile, isZoomedRef]);
    const handleTouchMovePageMenu = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        if (!fullScreen) return;
        if (e.touches.length > 1) {
            pinchDetected.current = true;
            return;
        }
        if (isSwipeBlocked.current || pinchDetected.current) return;
        const deltaX = e.touches[0].clientX - touchStartX.current;
        const deltaY = e.touches[0].clientY - touchStartY.current;

        if (Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
            isHorizontalSwipe.current = true;
            if (e.cancelable) e.preventDefault();
        }
    },[fullScreen]);
    const handleTouchEnd = useCallback((e: React.TouchEvent<HTMLDivElement>) => {
        if (!fullScreen) return;
        if (isSwipeBlocked.current) {
            isSwipeBlocked.current = false;
            return;
        }
        if (!isHorizontalSwipe.current || e.changedTouches.length > 1 || pinchDetected.current) {
            pinchDetected.current = false;
            return;
        }
        const touchEndX = e.changedTouches[0].clientX;
        const distance = touchEndX - touchStartX.current;
        if (distance < -50) {
            if((pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) < lengthMenuPhone) {
                clickRightPageTel();
            }
        } else if(distance > 50) {
            if(pageShow[0] > 0) clickLeftPageTel()
        }
        
    },[fullScreen,pageShow, lengthMenuPhone, clickRightPageTel, clickLeftPageTel]);

    const handleFullScreen = () => {
        if(isMobile) {
            if (fullScreen) restoreMobilePositionRef.current = true;
            else lastMobileActiveIndexRef.current = activeIndex;
            setFullScreen(!fullScreen);
            if(!fullScreen)nudgeScroll()
            setPageShow([0,1])
        }
    }

    const listRef = useRef<HTMLDivElement | null>(null);
    const [scaleReady, setScaleReady] = useState(false);
    
    const scalesRef = useRef<Map<HTMLElement, number>>(new Map());
    const lastScrollLeftRef = useRef(0);
    const lastTRef = useRef(0);

    const scrollToFirstCardCenter = useCallback(() => {
        const scroller = listRef.current;
        if (!scroller) return false;
        //const cards = Array.from(scroller.querySelectorAll<HTMLElement>(".containerCoverMenu"));
        const cards = mobileMenuItemRefs.current;
        if (!cards.length) return false;

        const firstCard = cards[0];
        if(!firstCard) return false;
        const target = firstCard.offsetLeft - (scroller.clientWidth - firstCard.offsetWidth) / 2;

        if (Math.abs(scroller.scrollLeft - target) <= 2) return true;

        scroller.classList.add("snapOff");
        scroller.scrollTo({ left: target, top: 0, behavior: "auto" });

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
            scroller.scrollTo({ left: target, top: 0, behavior: "auto" });
            scroller.classList.remove("snapOff");
            });
        });

        return true;
    }, [currentDaily]);
    const timeoutsRef = useRef<number[]>([]);

    const clearCenteringTimeouts = () => {
        timeoutsRef.current.forEach((id) => clearTimeout(id));
        timeoutsRef.current = [];
    };

    const runStableCentering = useCallback(() => {
        const scroller = listRef.current;
        if (!scroller) return;

        clearCenteringTimeouts();

        let tries = 0;
        let last = scroller.scrollLeft;

        const step = () => {
            tries++;

            const done = scrollToFirstCardCenter(); 
            const now = scroller.scrollLeft;
            if (done && Math.abs(now - last) <= 1) return;
            if (tries >= 8) return; 

            last = now;
            requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
        timeoutsRef.current.push(window.setTimeout(() => scrollToFirstCardCenter(), 80));
        timeoutsRef.current.push(window.setTimeout(() => scrollToFirstCardCenter(), 240));
        timeoutsRef.current.push(window.setTimeout(() => scrollToFirstCardCenter(), 700));
    }, [scrollToFirstCardCenter]);

    useLayoutEffect(() => {
        if (!isMobile || fullScreen) return;
        if (!listRef.current) return;

        if (restoreMobilePositionRef.current) {
            requestAnimationFrame(() => {
                scrollToMobileIndex(lastMobileActiveIndexRef.current, "auto");
                restoreMobilePositionRef.current = false;
            });
        } else runStableCentering();

        const onPageShow = (e: PageTransitionEvent) => {
            runStableCentering();
        };

        let lastWindowWidth = window.innerWidth;
        const vv = window.visualViewport;
        let lastVVWidth = vv?.width ?? 0;

        const onWindowResize = () => {
            const nextWidth = window.innerWidth;
            if (Math.abs(nextWidth - lastWindowWidth) < 2) return;
            lastWindowWidth = nextWidth;
            runStableCentering();
        };

        const onVVResize = () => {
            const nextWidth = vv?.width ?? 0;
            if (Math.abs(nextWidth - lastVVWidth) < 2) return;
            lastVVWidth = nextWidth;
            runStableCentering();
        };

        const onOrientationChange = () => {
            lastWindowWidth = window.innerWidth;
            lastVVWidth = vv?.width ?? 0;
            runStableCentering();
        };
        const onVV = () => runStableCentering();

        window.addEventListener("pageshow", onPageShow);
        window.addEventListener("resize", onWindowResize, { passive: true });
        window.addEventListener("orientationchange", onOrientationChange);

        if (vv) {
            vv.addEventListener("resize", onVVResize, { passive: true });
        }
        const scroller = listRef.current!;
        const imgs = Array.from(scroller.querySelectorAll("img"));
        const onImgLoad = () => runStableCentering();
        imgs.forEach((img) => {
            if (!img.complete) img.addEventListener("load", onImgLoad, { once: true });
        });

        return () => {
            clearCenteringTimeouts()
            window.removeEventListener("pageshow", onPageShow);
            window.removeEventListener("resize", onWindowResize);
            window.removeEventListener("orientationchange", onOrientationChange);
            if (vv) {
            vv.removeEventListener("resize", onVVResize);
            }
        };
        }, [isMobile,fullScreen,currentDaily,mergedMenuList.length,dailyMenu?.image,runStableCentering,
    ]);

    useEffect(() => {
        if (fullScreen || !isMobile) return;
        const scroller = listRef.current;
        if (!scroller) return;

        let raf = 0;

        const update = () => {
            raf = 0;
            //const items = Array.from(scroller.querySelectorAll<HTMLElement>(".containerCoverMenu"));
            const items = mobileMenuItemRefs.current;
            if (!items.length) return;

            const rW = scroller.clientWidth;
            const centerX = scroller.scrollLeft + rW / 2;

            let bestIdx = 0;
            let bestDist = Infinity;
            for (let i = 0; i < items.length; i++) {
                const el = items[i];
                if (!el) continue;
                const center = el.offsetLeft + el.offsetWidth / 2;
                const dist = Math.abs(center - centerX);
                if (dist < bestDist) { bestDist = dist; bestIdx = i; }
            }
            setActiveIndex(bestIdx);
            setScaleReady(true);
        };

        const schedule = () => { if (!raf) raf = requestAnimationFrame(update); };
        scroller.addEventListener("scroll", schedule, { passive: true });
        requestAnimationFrame(update);

        return () => {
            scroller.removeEventListener("scroll", schedule);
            if (raf) cancelAnimationFrame(raf);
        };
    }, [fullScreen, isMobile, mergedMenuList?.length]);

    return (
        <>{fullScreen && <div className="maskFullScreenRestauTel"> <MaskBackground /> </div>}
        
        {isMobile && (fullScreen || menuPdf || dailyMenuFullScreen) && <div className="maskHeightFullScreen"></div>}
        <div className={`containerMenuBase secondaryBack ${(fullScreen || (!isMobile && openedMenu) || (menuPdf) || (dailyMenuFullScreen)) ? 'isFullScreen' : ''}`} >
            
            <div className={`mainCorp ${uniqueMenuDesk ? 'isMainUnique' : ''}`} >
                {!fullScreen && mergedMenuList.length > 1 && <div className="slideImgList">
                    {
                        mergedMenuList.map((elem,id) => {
                            return <div key={'elemSlide'+id} className={`${activeIndex === id && 'select'} pointer ${(activeIndex === id+1 || activeIndex === id-1) && 'nextSelect'}`} onClick={() => {if(activeIndex !== id){if(isMobile){scrollToMobileIndex(id)}else{scrollToIndex(id)}}}}>
                            </div>
                        })
                    }
                </div>}
                {
                    !isMobile && 
                    <>
                    {!openedMenu && !menuPdf && !dailyMenuFullScreen && <div className="menuNavComputer">
                        {activeIndex > 0 && (
                        <button className="chevron chevronLeft pointer lowOpacityHover" onClick={() => scrollToIndex(activeIndex - 1)} aria-label="Précédent">
                            <FiChevronLeft size={28} className="icon" />
                        </button>
                        )}
        
                        {activeIndex < mergedMenuList.length-1 && (
                        <button className="chevron chevronRight pointer lowOpacityHover" onClick={() => scrollToIndex(activeIndex + 1)} aria-label="Suivant">
                            <FiChevronRight size={28} className="icon"  />
                        </button>
                        )}
                    </div>}
                    {mergedMenuList.length > 1 ? <div className={`listMenuComputer ${scaleReady ? "scaleReady" : ""}`} ref={listRefComputer}>
                        <div className="spacer-start" aria-hidden="true" />
                        {
                            mergedMenuList.map((elemMenu,id) => {
                                if(elemMenu.type === 'daily') return <DailyMenuList id={id} activeIndex={activeIndex} itemRef={(el) => setMenuItemRef(id, el)} scrollToIndex={scrollToIndex} setDailyMenuFullScreen={setDailyMenuFullScreen} dailyMenu={dailyMenu} isForDesk={true}/>
                                const elem = elemMenu.data
                                const [menuQr,styleMenuQr] = getMenuAndStyle(elem)
                                const periodDisplay = getPeriodDisplay(elem,true);
                                const borderPageQr = menuQr && 'borderpage' in menuQr[0][1] && menuQr[0][1].borderpage ? menuQr[0][1].borderpage : null;
                                const isPdfMenu = isPdfMenuItem(elem);
                                return <div key={`${elem.isbase ? "base" : "extra"}-${elem.id ?? "new"}-${id}`} ref={(el) => setMenuItemRef(id, el)}  className={`containerMenu  ${elem.menu ? 'isDobble' : ''} ${elem.menu && borderPageQr && 'transparent' in borderPageQr ? 'borderNotVisible' : ''} ${isPdfMenu ? 'isPdf' : ''} ${id === activeIndex ? 'isCenter' : 'isNotCenter'}`} onClick={(e) => {
                                        e.stopPropagation();
                                        if (id !== activeIndex) {
                                            scrollToIndex(id);
                                        }
                                    }}>
                                    <div className="coverMenu" onClick={() => {}}  style={styleMenuQr ?? undefined} >   
                                        {!isPdfMenu && <><div className={`pagesEffectLeft primaryBack style${elem.stylemenu || 0} ${borderPageQr && 'transparent' in borderPageQr ? 'notVisible' : ''}`}></div>
                                        <div className={`pagesEffectRight primaryBack style${elem.stylemenu || 0} ${borderPageQr && 'transparent' in borderPageQr ? 'notVisible' : ''}`}></div>
                                            </>}   
                                        <div className="contentCover">
                                            <div className="maskContent pointer">
                                                <span className="smallWhiteButton smallText" onClick={(e) => {e.stopPropagation();if(isPdfMenu){handleOpenMenuPdf(elem,id,true)}else{handleOpenMenuDesktop(elem,id);}}}>
                                                    <MdFullscreen className="icon" size={18}/>
                                                    Afficher
                                                </span>
                                            </div>
                                            {menuQr ? <div className="menuRestau flexAllCenter" >
                                                <div className={`pageRestau smallText flipped`}  >
                                                    <PageMenu   pageShow={0} content={menuQr[0][1]} index={0} front={false} frontTel={false} StyleMenu={elem.stylemenu || 0}  isInteract={elem.interactmenu || false}  />
                                                </div> 
                                                <div className={`pageRestau smallText `}  >
                                                    <PageMenu   pageShow={0} content={menuQr[1][0]} index={1} front={true} frontTel={true} StyleMenu={elem.stylemenu || 0}  isInteract={elem.interactmenu || false}  />
                                                </div>
                                            </div> : isPdfMenu ? <div className="pdfMenuPreview">
                                                <img
                                                    src={elem.link_img_pdf}
                                                    alt={elem.name || "Aperçu du PDF"}
                                                    className="pdfMenuImage"
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                            </div> : <></>}
                                        </div>
                                    </div>
                                    <div className="footerPartCover">
                                        <span className="largeTitle">{elem.name ?? ""}</span>
                                        <i className="dateUpdate XsmallText">
                                            <span>{periodDisplay.text}</span>
                                        </i>
                                        {
                                            (elem.interactmenu || false) && <span className="textInteract smallText"><MdOutlinePhotoCamera className="icon" style={{marginTop:'2px'}}/> Carte interactive</span>
                                        }
                                    </div>
                                </div>
                            })
                        }
                        <div className="spacer-end" aria-hidden="true" />
                    </div>
                    : uniqueMenuDesk ? <>
                    <div className="menuUniqueDesktop flexAllCenter">
                        {pageShow[0] === 0 ?
                            <div className="borderMenuRestau" style={{marginRight:'1%'}}></div>
                            :
                            <div className="borderMenuRestau lowOpacityHover" style={{marginRight:'1%'}} onClick={(e) => {e.stopPropagation();clickLeftPage()}}>
                                <div  className="pointer ">
                                    <FiChevronLeft size={30}  /> 
                                </div>
                            </div>
                        }   
                        <div className='menuRestau' style={borderStyleVars} onClick={(e) => e.stopPropagation()}>
                            <div className={`pagesEffectLeft primaryBack style${uniqueStyleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                            <div className={`pagesEffectRight primaryBack style${uniqueStyleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                            {
                            dobbleMenu.map((elem,idMenu) => {
                                return (
                                    idMenu === 0 ? 
                                        <div className={`pageRestau flipped`} id='page0' key={`pageResto0`} >
                                            <PageMenu key={"pageRestoFF0"+idMenu} pageShow={pageShow[1]} content={emptyMenuPage} index={idMenu} front={true} StyleMenu={uniqueStyleMenu} isInteract={uniqueInteractMenu} frontTel={true}/>
                                            <PageMenu key={"pageRestoFB1"+idMenu} pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} StyleMenu={uniqueStyleMenu} isInteract={uniqueInteractMenu} frontTel={false}/>
                                        </div>     
                                    : 
                                    <div className='pageRestau smallText' key={`pageResto0${idMenu}`} id={`pageRestau${idMenu}`} style={{zIndex: maxIndex - idMenu}}>
                                        <PageMenu key={"pageRestoF0"+idMenu} pageShow={pageShow[1]} content={elem[0] ?? emptyMenuPage} index={idMenu} front={true} StyleMenu={uniqueStyleMenu} isInteract={uniqueInteractMenu} frontTel={true}/>
                                        <PageMenu key={"pageRestoB1"+idMenu} pageShow={pageShow[0]} content={elem[1] ?? emptyMenuPage} index={idMenu} front={false} StyleMenu={uniqueStyleMenu} isInteract={uniqueInteractMenu} frontTel={false}/>
                                    </div> )
                            })
                            }
                            <div className="bottomInfo">
                                <span className="midTitle">{uniqueNameMenu}</span>
                                <i className="dateUpdate XsmallText">{getPeriodDisplay(uniqueMenuDesk,true).text}</i>
                            </div>
                        </div>
                        <div className="borderMenuRestau pointer lowOpacityHover"  style={{marginLeft:'1%'}} onClick={(e) => {if(pageShow[1] <= dobbleMenu.length-1 - (dobbleMenu[dobbleMenu.length-1][1].elements.length > 0 ? 0 : 1 )){e.stopPropagation();clickRightPage();}} }> {  pageShow[1] <= dobbleMenu.length-1 - (dobbleMenu[dobbleMenu.length-1][1].elements.length > 0 ? 0 : 1 )&& 
                            <div   className="pointer ">
                                <FiChevronRight size={30}   /> 
                            </div>
                            } 
                        </div>
                        {uniqueInteractMenu && <RightBar isFullScreen={fullScreen} dobbleMenu={dobbleMenu} setFullPlat={setFullPlat}/>}
                    </div>
                    </> : <div className="maskBeforeUniqueMenu"></div>}
                    </>
                }

                {isMobile && fullScreen && (
                <div
                    className="closeOverlay"
                    onClick={() => { restoreMobilePositionRef.current = true; setFullScreen(false)}}
                />
                )}
               {isMobile && <div className={`menuRestauTel ${fullScreen ? 'isFullScreen' : 'notFullScreen'} ${dailyMenuFullScreen ? 'isFullScreenDaily' : ''} ${menuPdf ? 'isFullScreenPdf' : ''}`} 
                    onTouchStart={fullScreen ? handleTouchStart : undefined}
                    onTouchMove={fullScreen ? handleTouchMovePageMenu : undefined}
                    onTouchEnd={fullScreen ? handleTouchEnd : undefined}>
                    {!fullScreen ? 
                        <div className={`listMenu `}  ref={listRef}>
                            {mergedMenuList.length > 1  && <div className="spacer-start" aria-hidden="true" />}
                            {
                                mergedMenuList.map((elemMenu,id) => {
                                    if(elemMenu.type === 'daily') return <DailyMenuList id={id} activeIndex={activeIndex} itemRef={(el) => { mobileMenuItemRefs.current[id] = el; }} scrollToIndex={scrollToMobileIndex} setDailyMenuFullScreen={setDailyMenuFullScreen} dailyMenu={dailyMenu} />
                                    const elem = elemMenu.data
                                    const [menuQr,styleMenuQr] = getMenuAndStyle(elem)
                                    const periodDisplay = getPeriodDisplay(elem,true);
                                    const isPdfMenu = isPdfMenuItem(elem);
                                    return  <div key={`${elem.isbase ? "base" : "extra"}-${elem.id ?? "new"}-${id}`} ref={(el) => {mobileMenuItemRefs.current[id] = el;}} className={`containerCoverMenu ${isPdfMenu ? 'isPdf' : ''} ${activeIndex === id ? 'isActive' : ''} ${Math.abs(activeIndex - id) === 1 ? 'isNearActive' : ''}`} onClick={(e) => {
                                        e.stopPropagation();
                                        if (id !== activeIndex) {
                                            scrollToMobileIndex(id);
                                        }}}>
                                        <div className="coverMenu"  style={styleMenuQr ?? undefined} >   
                                            <div className="contentCover"> 
                                                {menuQr ?
                                                    <div className={`pageRestauTel smallText flipped`}  >
                                                        <PageMenu   pageShow={0} content={menuQr[0][1]} index={0} front={false} frontTel={false} StyleMenu={elem.stylemenu || 0}  isInteract={elem.interactmenu || false} isPhone={true} />
                                                    </div>  : isPdfMenu ? <div className="pdfMenuPreview">
                                                <img
                                                    src={elem.link_img_pdf}
                                                    alt={elem.name || "Aperçu du PDF"}
                                                    className="pdfMenuImage"
                                                    loading="lazy"
                                                    decoding="async"
                                                />
                                            </div> : <></>}
                                            </div>
                                            {!isPdfMenu && <div className={`pagesEffectRight style${elem.stylemenu || 0} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>}
                                            
                                            <div className="maskCover"></div>
                                            <div className="fullScreenButton smallTextBold primaryBack" onClick={(e) => {e.stopPropagation();if(isPdfMenu){handleOpenMenuPdf(elem,id,true)}else{handleOpenMenuMobile(elem)}}}>
                                                <MdFullscreen className="icon" size={18}/>
                                                <span>Afficher</span>
                                            </div>
                                        </div>
                                        <div className="footerPartCover">
                                            <span className="largeTitle">{elem.name || 'La Carte'}</span>
                                             <i className="dateUpdate XsmallText">
                                                <span>{periodDisplay.text}</span>
                                            </i>
                                            {
                                             <span className="textInteract smallText" style={{opacity:(elem.interactmenu || false) ? 1 : 0}}><MdOutlinePhotoCamera className="icon" style={{marginTop:'1px'}}/> Carte interactive</span>
                                            }
                                        </div>
                                    
                                    </div>
                                })
                            }
                            {mergedMenuList.length > 1  && <div className="spacer-end" aria-hidden="true" />}
                        </div>
                                :

                                <>{
                                openedMenu && dobbleMenu.map((elem,idMenu) => {
                                    if(pageShow[1] + 1 < idMenu) return null;
                                    const dist = Math.abs(pageShow[0] - idMenu);
                                    const isNear = dist <= 2;
                                    const perfStyle = canUseContentVisibility && !isNear ? ({ contentVisibility: "auto", containIntrinsicSize: "432px 612px" }as const): undefined;           
                                    const willChangeStyle = isNear ? ({ willChange: "transform" } as const) : undefined;
                                    return ( 
                                            <React.Fragment key={`pageRestotel01${idMenu}`}>
                                                
                                                <div className={`pageRestauTel smallText  ${idMenu === 0 ? 'flipped' : ''}`}  id={`pageRestauTel0${idMenu}`} style={{...perfStyle,...willChangeStyle}} >
                                                    <PageMenu key={"pageRestoB1"+idMenu+Number(fullScreen)}  pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} frontTel={false} StyleMenu={openedStyleMenu}  isInteract={openedInteractMenu} isPhone={true}  />                                 
                                                </div>
                                                {idMenu !== 0 && 
                                                <div className={`pageRestauTel smallText `}   id={`pageRestauTel1${idMenu}`} style={{...perfStyle,...willChangeStyle}} >
                                                    <PageMenu key={"pageRestoF0"+idMenu+Number(fullScreen)} pageShow={pageShow[1]} content={elem[0]} index={idMenu} front={false} frontTel={true} StyleMenu={openedStyleMenu}  isInteract={openedInteractMenu} isPhone={true} />
                                                </div> }
                                
                                            </React.Fragment>
                                        )
                                    })}
                                <div className={`iconFullScren `} onClick={handleFullScreen}><div><TfiClose className="icon" size={12}/></div></div>
                                {openedMenu?.interactmenu &&  <span className="XsmallText hookInteractPhone">
                                    Cliquer sur un plat avec “ <MdOutlinePhotoCamera className="iconPhoto" size={13} /> ” pour le découvrir en image.
                                </span>}
                        </>
                    }
                    
                    {fullScreen && <div className="bottomInfo">
                        
                        <div className="numberPagesPhone smallText">
                            <div className={`${(pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) <= 1 ? 'lock' : ''}`} style={lengthMenuPhone === 1 ? {opacity:0} :{} } onClick={() => {if(pageShow[0] > 0) {clickLeftPageTel()}}}><FiChevronLeft className="buttonTurn" size={18}/></div>
                            <span>{pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)}/{lengthMenuPhone}</span>
                            <div className={`${(pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) >= lengthMenuPhone ? 'lock' : ''}`} style={lengthMenuPhone === 1 ? {opacity:0} :{} } onClick={() => {if((pageShow[1]*2 - (pageShow[0]!==pageShow[1] ? 1 : 0)) < lengthMenuPhone){clickRightPageTel()}}}><FiChevronRight className="buttonTurn" size={18} /></div>
                        </div>
                    </div>}
                </div> }

                {
                    menuPdf && <>
                        <div className="closeOverlay forPdf" onClick={() => setMenuPdf(null)}></div>
                        <div className="menuPdf" onClick={closeMenu}>
                            <div className="containerImg">
                                <TfiClose className="close pointer lowOpacityHover" onClick={() => setMenuPdf(null)} size={18} />
                                <img className="imgPdf" src={menuPdf.link_img_pdf ?? ''} alt="Menu" decoding="async" loading="lazy"></img>
                                
                            </div>
                            <div className="footerPartPdf">
                                <i className="dateUpdate XsmallText">{getPeriodDisplay(menuPdf,true).text}</i>
                            </div>
                        </div>
                        <MaskBackground zIndex={9} closeFunction={() => setMenuPdf(null)} />
                    </>
                }
                {
                    dailyMenuFullScreen && <>
                        <div className="closeOverlay forPdf" onClick={() => setDailyMenuFullScreen(null)}></div>
                        <div className="menuPdf" onClick={closeMenu}>
                            <div className="containerImg">
                                <TfiClose className="close pointer lowOpacityHover" onClick={() => setDailyMenuFullScreen(null)} size={18} />
                                <img className="imgPdf" src={dailyMenuFullScreen.image ?? ''} alt="Menu du jour" loading="lazy" decoding="async"></img>
                                
                            </div>
                            <div className="footerPartPdf">                      
                                <i className="dateUpdate XsmallText" style={{gap:0}}>
                                    <span>{'Menu du '}</span>
                                    {dailyMenuFullScreen.dates.length === 1 ?
                                    <span>
                                        {new Intl.DateTimeFormat("fr-FR", {
                                            weekday: "long",
                                            day: "numeric",
                                            month: "long"
                                        })
                                        .format(new Date(dailyMenuFullScreen.dates[0]))
                                        .replace(/^./, (str) => str.toUpperCase())}
                                    </span> : <>
                                        <span>{new Date(dailyMenuFullScreen.dates[0]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}</span>
                                        <span style={{ marginRight: '5px', marginLeft: '5px' }}>au</span>
                                        <span>{new Date(dailyMenuFullScreen.dates[1]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}</span>
                                
                                    </>}
                                </i>
                            </div>
                        </div>
                        <MaskBackground zIndex={9} closeFunction={() => setDailyMenuFullScreen(null)} />
                    </>
                }

                {!isMobile && openedMenu && <>
                <div className="closeOverlay forDesktop"></div>
                <div className="menuFullScreenDesktop flexAllCenter" onClick={closeMenu}>
                    <TfiClose size={18} className="closeFullScreen pointer lowOpacityHover" />
                    {pageShow[0] === 0 ?
                        <div className="borderMenuRestau" style={{marginRight:'1%'}}></div>
                        :
                        <div className="borderMenuRestau lowOpacityHover" style={{marginRight:'1%'}} onClick={(e) => {e.stopPropagation();clickLeftPage()}}>
                            <div  className="pointer ">
                                <FiChevronLeft size={30}  /> 
                            </div>
                        </div>
                    }   
                    <div className='menuRestau' style={borderStyleVars} onClick={(e) => e.stopPropagation()}>
                        <div className={`pagesEffectLeft primaryBack style${openedStyleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                        <div className={`pagesEffectRight primaryBack style${openedStyleMenu} ${borderPages && 'transparent' in borderPages ? 'notVisible' : ''}`}></div>
                        {
                        dobbleMenu.map((elem,idMenu) => {
                            return (
                                idMenu === 0 ? 
                                    <div className={`pageRestau flipped`} id='page0' key={`pageResto0`} >
                                        <PageMenu key={"pageRestoFF0"+idMenu} pageShow={pageShow[1]} content={emptyMenuPage} index={idMenu} front={true} StyleMenu={openedStyleMenu} isInteract={openedInteractMenu} frontTel={true}/>
                                        <PageMenu key={"pageRestoFB1"+idMenu} pageShow={pageShow[0]} content={elem[1]} index={idMenu} front={false} StyleMenu={openedStyleMenu} isInteract={openedInteractMenu} frontTel={false}/>
                                    </div>     
                                : 
                                <div className='pageRestau smallText' key={`pageResto0${idMenu}`} id={`pageRestau${idMenu}`} style={{zIndex: maxIndex - idMenu}}>
                                    <PageMenu key={"pageRestoF0"+idMenu} pageShow={pageShow[1]} content={elem[0] ?? emptyMenuPage} index={idMenu} front={true} StyleMenu={openedStyleMenu} isInteract={openedInteractMenu} frontTel={true}/>
                                    <PageMenu key={"pageRestoB1"+idMenu} pageShow={pageShow[0]} content={elem[1] ?? emptyMenuPage} index={idMenu} front={false} StyleMenu={openedStyleMenu} isInteract={openedInteractMenu} frontTel={false}/>
                                </div> )
                        })
                        }
                        <div className="bottomInfo">
                            <span className="smallTextBold">{pageShow[1]}/{dobbleMenu.length-1}</span>
                            <i className="dateUpdate XsmallText">{getPeriodDisplay(openedMenu,true).text}</i>
                        </div>
                    </div>
                    <div className="borderMenuRestau pointer lowOpacityHover"  style={{marginLeft:'1%'}} onClick={(e) => {if(pageShow[1] <= dobbleMenu.length-1 - (dobbleMenu[dobbleMenu.length-1][1].elements.length > 0 ? 0 : 1 )){e.stopPropagation();clickRightPage();}} }> {  pageShow[1] <= dobbleMenu.length-1 - (dobbleMenu[dobbleMenu.length-1][1].elements.length > 0 ? 0 : 1 )&& 
                        <div   className="pointer ">
                            <FiChevronRight size={30}   /> 
                        </div>
                        } 
                    </div>
                    {openedInteractMenu && <RightBar isFullScreen={fullScreen} dobbleMenu={dobbleMenu} setFullPlat={setFullPlat}/>}
                </div>
                <MaskBackground zIndex={49} closeFunction={closeMenu}/>
                </>}
                {openedInteractMenu && isMobile && <RightBar isFullScreen={fullScreen} dobbleMenu={dobbleMenu} setFullPlat={setFullPlat}/>}
            </div>   
        </div>
        </>
    )
}

export default MenuRestau


